/* @flow */
// <Trade/> сплитится на мобильный и десктопный
import React from "react";
import { Redirect } from "react-router-dom";
import FeatureFlags from "./FeatureFlags";
import Loadable from "./components/Loadable";
import Trade from "./pages/trade";

export default [
  {
    path: "/setup-webapp",
    exact: true,
    component: Loadable(
      () => import(/* webpackChunkName: "index" */ "./pages/index"),
      "pages/index"
    ),
  },
  {
    path: "/regbonus",
    component: Loadable(
      () => import(/* webpackChunkName: "regbonus" */ "./pages/regbonus"),
      "pages/regbonus"
    ),
  },
  {
    path: "/harakiri",
    component: Loadable(
      () => import(/* webpackChunkName: "harakiri" */ "./pages/harakiri"),
      "pages/harakiri"
    ),
  },
  /*{
    path: "/binary-options",
    component: Loadable(() =>
      import(/!* webpackChunkName: "binary-options" *!/ "./pages/binary-options"), "pages/binary-options"
    )
  },*/
  {
    path: "/",
    exact: true,
    component: Loadable(
      () => import(/* webpackChunkName: "analytics" */ "./pages/analytics"),
      "pages/analytics"
    ),
  },
  {
    path: "/item/:id",
    component: Loadable(
      () => import(/* webpackChunkName: "signal-item" */ "./pages/signal-item"),
      "pages/signal-item"
    ),
  },
  {
    path: "/news",
    exact: true,
    component: Loadable(
      () =>
        FeatureFlags.enableHelpdeskNews === true && process.env.REACT_APP_DEPLOY_TARGET !== "eztrader"
          ? import(/* webpackChunkName: "news" */ "./pages/news")
          : import(/* webpackChunkName: "404" */ "./pages/404"),
      "pages/news"
    ),
  },
  {
    path: "/news/:id",
    component: Loadable(
      () =>
        FeatureFlags.enableHelpdeskNews === true && process.env.REACT_APP_DEPLOY_TARGET !== "eztrader"
          ? import(/* webpackChunkName: "news-item" */ "./pages/news-item")
          : import(/* webpackChunkName: "404" */ "./pages/404"),
      "pages/news-item"
    ),
  },
  {
    path: "/error",
    component: Loadable(
      () => import(/* webpackChunkName: "error" */ "./pages/error"),
      "pages/error"
    ),
  },
  {
    path: "/trade/:stock*",
    render: ({ match }: Object) => <Trade stock={match.params.stock} />,
  },
  {
    path: "/conditions",
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? import(/* webpackChunkName: "404" */ "./pages/404")
          : import(/* webpackChunkName: "conditions" */ "./pages/conditions"),
      "pages/conditions"
    ),
  },
  {
    path: "/risk-notifications",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "risk-notifications" */ "./pages/risk-notifications"),
      "pages/risk-notifications"
    ),
  },
  {
    path: "/payment-privacy",
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? import(/* webpackChunkName: "404" */ "./pages/404")
          : import(/* webpackChunkName: "payment-privacy" */ "./pages/payment-privacy"),
      "pages/payment-privacy"
    ),
  },
  {
    path: "/payment-policy",
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? import(/* webpackChunkName: "404" */ "./pages/404")
          : import(/* webpackChunkName: "payment-policy" */ "./pages/payment-policy"),
      "pages/payment-policy"
    ),
  },
  {
    path: "/privacy-policy",
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? import(/* webpackChunkName: "404" */ "./pages/404")
          : import(/* webpackChunkName: "privacy-policy" */ "./pages/privacy-policy"),
      "pages/privacy-policy"
    ),
  },
  {
    path: "/bonus-program",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "bonus-program" */ "./pages/bonus-program"),
      "pages/bonus-program"
    ),
  },
  /*{
    path: "/binaryvsoptions",
    component: Loadable(() =>
      import(/!* webpackChunkName: "binary-vs-options" *!/ "./pages/binary-vs-options"), "pages/binary-vs-options"
    )
  },*/
  {
    path: "/return-refund-policy",
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? import(/* webpackChunkName: "404" */ "./pages/404")
          : import(/* webpackChunkName: "return-refund-policy" */ "./pages/return-refund-policy"),
      "pages/return-refund-policy"
    ),
  },
  {
    path: "/aml-policy",
    component: Loadable(
      () => import(/* webpackChunkName: "aml-policy" */ "./pages/aml-policy"),
      "pages/aml-policy"
    ),
  },
  {
    path: "/profile",
    component: Loadable(
      () => import(/* webpackChunkName: "profile" */ "./pages/profile"),
      "pages/profile"
    ),
  },
  // {
  //   path: "/verification",
  //   component: Loadable(
  //     () =>
  //       import(/* webpackChunkName: "verification" */ "./pages/verification"),
  //     "pages/verification"
  //   )
  // },
  {
    path: "/verification",
    component: () => <Redirect to="/profile" />,
  },
  {
    path: "/fillup",
    component: Loadable(
      () => import(/* webpackChunkName: "fillup" */ "./pages/fillup"),
      "pages/fillup"
    ),
  },
  {
    path: "/billing/kerry-express",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "fillup-kerry-express" */ "./pages/billing-kerry-express"),
      "pages/billing-kerry-express"
    ),
  },
  {
    path: "/about",
    component: Loadable(
      () => import(/* webpackChunkName: "about" */ "./pages/about"),
      "pages/about"
    ),
  },
  {
    path: "/ios-about",
    component: Loadable(
      () => import(/* webpackChunkName: "about" */ "./pages/about"),
      "pages/about"
    ),
  },
  {
    path: "/email/confirm/success",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "confirm-email" */ "./pages/confirm-email"),
      "pages/confirm-email"
    ),
  },
  {
    path: "/email/confirm/error",
    component: Loadable(
      () => import(/* webpackChunkName: "error-email" */ "./pages/error-email"),
      "pages/error-email"
    ),
  },
  {
    path: "/faq",
    component: () => <Redirect to="/helpdesk/faq#intro" />,
  },
  {
    path: "/ios-faq",
    component: Loadable(
      () => import(/* webpackChunkName: "faq" */ "./pages/faq"),
      "pages/faq"
    ),
  },
  {
    path: "/withdraw-old",
    component: Loadable(
      () => import(/* webpackChunkName: "withdraw" */ "./pages/withdraw"),
      "pages/withdraw"
    ),
  },
  {
    path: "/withdraw",
    component: Loadable(
      () => import(/* webpackChunkName: "withdraw" */ "./pages/withdraw-new"),
      "pages/withdraw-new"
    ),
  },
  {
    path: "/support",
    component: Loadable(
      () => import(/* webpackChunkName: "support" */ "./pages/support"),
      "pages/support"
    ),
  },
  {
    path: "/ios-support",
    component: Loadable(
      () => import(/* webpackChunkName: "support" */ "./pages/support"),
      "pages/support"
    ),
  },
  {
    path: "/unsubscribe",
    component: Loadable(
      () => import(/* webpackChunkName: "unsubscribe" */ "./pages/unsubscribe"),
      "pages/unsubscribe"
    ),
  },
  {
    path: "/tutorials",
    component: Loadable(
      () => import(/* webpackChunkName: "tutorials" */ "./pages/tutorials"),
      "pages/tutorials"
    ),
  },
  {
    path: "/trading-history",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "trading-history" */ "./pages/trading-history"),
      "pages/trading-history"
    ),
  },
  {
    path: "/finance-history",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "finance-history" */ "./pages/finance-history"),
      "pages/finance-history"
    ),
  },
  {
    path: "/login",
    component: Loadable(
      () => import(/* webpackChunkName: "login" */ "./pages/login"),
      "pages/login"
    ),
  },
  {
    path: "/ios",
    component: Loadable(
      () => import(/* webpackChunkName: "login" */ "./pages/index"),
      "pages/index"
    ),
  },
  {
    path: "/register",
    component: Loadable(
      () => import(/* webpackChunkName: "register" */ "./pages/register"),
      "pages/register"
    ),
  },
  {
    path: "/logout",
    component: Loadable(
      () => import(/* webpackChunkName: "logout" */ "./pages/logout"),
      "pages/logout"
    ),
  },
  {
    path: "/billing/offline",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "offline-billing" */ "./pages/offline-billing"),
      "pages/offline-billing"
    ),
  },
  {
    path: "/password-update",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "change-password" */ "./pages/change-password"),
      "pages/change-password"
    ),
  },
  {
    path: "/billing/*/success",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-success" */ "./pages/billing-success"),
      "pages/billing-success"
    ),
  },
  {
    path: "/billing/*/return",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-return" */ "./pages/billing-success"),
      "pages/billing-success"
    ),
  },
  {
    path: "/billing/*/complete",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-return" */ "./pages/billing-success"),
      "pages/billing-success"
    ),
  },
  {
    path: "/billing/*/fail",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-fail" */ "./pages/billing-fail"),
      "pages/billing-fail"
    ),
  },
  {
    path: "/billing/success",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-success" */ "./pages/billing-success"),
      "pages/billing-success"
    ),
  },
  {
    path: "/billing/return",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-return" */ "./pages/billing-success"),
      "pages/billing-success"
    ),
  },
  {
    path: "/billing/complete",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-return" */ "./pages/billing-success"),
      "pages/billing-success"
    ),
  },
  {
    path: "/billing/fail",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-fail" */ "./pages/billing-fail"),
      "pages/billing-fail"
    ),
  },
  {
    path: "/billing/redirect",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "billing-redirect" */ "./pages/billing-redirect"),
      "pages/billing-redirect"
    ),
  },

  // qr-кодов вроде не будет, но будем считать, что страничка есть
  {
    path: "/billing/paytoday/show_qr",
    component: Loadable(
      () => import(/* webpackChunkName: "billing-qr" */ "./pages/billing-qr"),
      "pages/billing-qr"
    ),
  },

  // helpdesk index page
  {
    path: "/contacts",
    component: Loadable(
      () =>
        FeatureFlags.enableHelpdesk === true
          ? import(/* webpackChunkName: "helpdesk" */ "./pages/helpdesk")
          : import(/* webpackChunkName: "404" */ "./pages/404"),
      "pages/helpdesk"
    ),
  },
{
  path: "/aboutus",
      component: Loadable(
    () =>
        FeatureFlags.enableHelpdesk === true
            ? import(/* webpackChunkName: "helpdesk" */ "./pages/helpdesk")
            : import(/* webpackChunkName: "404" */ "./pages/404"),
    "pages/helpdesk"
),
},
  {
    path: "/promo",
    component: Loadable(
      () => import(/* webpackChunkName: "promo" */ "./pages/promo"),
      "pages/promo"
    ),
  },
  {
    path: "/sightseeing",
    component: Loadable(
      () => import(/* webpackChunkName: "sightseeing" */ "./pages/sightseeing"),
      "pages/sightseeing"
    ),
  },
  {
    path: "/app-download",
    exact: true,
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "eztrader"
          ? import(/* webpackChunkName: "404" */ "./pages/404")
          : import(/* webpackChunkName: "app-download" */ "./pages/app-download"),
      "pages/app-download"
    ),
  },
  {
    path: "/tournaments",
    exact: true,
    component: Loadable(
      () =>
        FeatureFlags.enableTournaments === true
          ? import(/* webpackChunkName: "tournaments" */ "./pages/tournaments")
          : import(/* webpackChunkName: "404" */ "./pages/404"),
      "pages/tournaments"
    ),
  },
  {
    path: "/tournaments/:id",
    component: Loadable(
      () =>
        FeatureFlags.enableTournaments === true
          ? import(/* webpackChunkName: "tournament" */ "./pages/tournament")
          : import(/* webpackChunkName: "404" */ "./pages/404"),
      "pages/tournament"
    ),
  },
  // {
  //   path: "/exclusive-strategy/",
  //   exact: true,
  //   component: Loadable(() =>
  //     import(/* webpackChunkName: "exclusive-strategy-list" */ "./pages/exclusive-strategy-list.js"), "pages/exclusive-strategy-list.js"
  //   )
  // },
  {
    path: "/exclusive-strategy/:name",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "exclusive-strategy" */ "./pages/exclusive-strategy"),
      "pages/exclusive-strategy"
    ),
  },
  {
    path: "/ironcard/:bool",
    component: Loadable(
      () =>
        process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
          ? import(/* webpackChunkName: "ironcard" */ "./pages/ironcard")
          : import(/* webpackChunkName: "404" */ "./pages/404"),
      "pages/ironcard"
    ),
  },
  {
    path: "/new-fillup",
    component: Loadable(
      () =>
        import(/* webpackChunkName: "exclusive-strategy" */ "./pages/html/fillup/index"),
      "pages/html/fillup/index"
    ),
  },
  {
    path: "/test-for-users",
    component: Loadable(() =>
      import(/* webpackChunkName: "test-for-users" */ "./pages/test-for-users")
    ),
  },
  {
    path: "/complaint-handling-policy",
    component: Loadable(() =>
      process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
        ? import(/* webpackChunkName: "complaint-handling-policy" */ "./pages/complaint-handling-policy")
        : import(/* webpackChunkName: "404" */ "./pages/404")
    ),
  },
  {
    path: "/withdrawal-funds-policy",
    component: Loadable(() =>
      process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
        ? import(/* webpackChunkName: "complaint-handling-policy" */ "./pages/withdrawal-funds-policy")
        : import(/* webpackChunkName: "404" */ "./pages/404")
    ),
  },
  {
    path: "/webview/rating",
    component: Loadable(() =>
      process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
        ? import(/* webpackChunkName: "webview-rating" */ "./pages/webview-rating")
        : import(/* webpackChunkName: "404" */ "./pages/404")
    ),
  },
  {
    path: "/bonus-review",
    component: Loadable(() =>
      import(/* webpackChunkName: "404" */ "./pages/404")
    ),
  },
];



// WEBPACK FOOTER //
// ./src/routes.js